import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class EndOn extends Field {
  static attributesForModel() {
    return ['endOn'];
  }

  get title() {
    return 'End on';
  }

  exampleContents(): FieldContentsData {
    return {
      text: dateFormattedWithUserLocale(moment().add(3, 'months')),
      icon: { name: 'fa-regular fa-hourglass-end' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.endOn) {
      return {
        text: dateFormattedWithUserLocale(record.endOn),
        icon: { name: 'fa-regular fa-hourglass-end' },
      };
    }

    return {};
  }
}
